import React from 'react';

/**
 * @typedef {object} BarChartTooltipPayload
 * @property {number} value
 */

/**
 * @typedef {object} BarChartTooltipProps
 * @property {boolean} [active]
 * @property {BarChartTooltipPayload[]} [payload]
 * @property {string|number} [label]
 */

/**
 * @param {BarChartTooltipProps} props
 */
const BarChartTooltip = props => {
  const { active, payload, label } = props;
  if (!active || !payload || !payload.length) {
    return null;
  }

  return (
    <div data-testid='bar-chart-tooltip' className='tooltip'>
      <p>{`${label}: ${payload[0].value.toFixed(0)}%`}</p>
    </div>
  );
};

export default BarChartTooltip;
